import { useMemo as o } from "react";
const s = (t) => o(() => {
  if (typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "xmlns"))
    return {
      type: "icon",
      icon: t
    };
  if (typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "iconSet")) {
    const e = t;
    return {
      type: "url",
      url: `url(${(e.dimension_value || e.value).replace(
        "https://a.storyblok.com",
        "https://a2.storyblok.com"
      )})`
    };
  }
  throw new Error("Icon is not valid");
}, [t]);
export {
  s as useIcon
};
